export const PATIENT_MEDICAL_DEVICE_ORDERING_DEFAULT_SORT = {
  sortedColumn: 'status',
  sortedColumnOrder: 'ascend'
}

export const PATIENT_MEDICAL_DEVICE_DISCAHRGE_REASON = [
  {
    key: 0,
    title: 'Patient activated by mistake',
    value: 1
  },
  {
    key: 1,
    title: 'Patient unhappy',
    value: 2
  },
  {
    key: 2,
    title: 'Device defect',
    value: 3
  },
  {
    key: 3,
    title: 'Patient monitor end',
    value: 4
  },
  {
    key: 4,
    title: 'Others',
    value: 5
  }
]

export const PATIENT_MEDICAL_DEVICE_DISCAHRGE_ACTION = [
  {
    key: 0,
    title: 'Deactivate and return link',
    value: 1
  },
  {
    key: 1,
    title: 'Transfer link',
    value: 2
  },
  {
    key: 2,
    title: 'Terminate subscription',
    value: 3
  }
]
